// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════
   Apps & Integrations screen
   ════════════════════════════════════════════════════════ */

.ai-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8fafc;
  font-family: inherit;
}

/* ── Header ─────────────────────────────────────────────── */
.ai-header {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 16px 20px 0;
  background: #fff;
  border-bottom: 1.5px solid #e2e8f0;
  flex-shrink: 0;
}

.ai-header-top {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.ai-back {
  width: 32px;
  height: 32px;
  border: 1.5px solid #e2e8f0;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  flex-shrink: 0;
  transition: border-color 0.15s, background 0.15s;
}
.ai-back:hover { background: #f1f5f9; border-color: #cbd5e1; }

.ai-header-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  line-height: 1.2;
}
.ai-header-sub {
  font-size: 11.5px;
  color: #64748b;
  margin: 1px 0 0;
  line-height: 1;
}

/* Search bar */
.ai-search-bar {
  display: flex;
  align-items: center;
  background: #f1f5f9;
  border-radius: 12px;
  height: 38px;
  padding: 0 12px;
  gap: 8px;
  margin-bottom: 12px;
  border: 1.5px solid #e2e8f0;
  transition: border-color 0.15s;
}
.ai-search-bar:focus-within { border-color: #2563eb66; }
.ai-search-icon { color: #94a3b8; flex-shrink: 0; }
.ai-search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #0f172a;
  font-size: 13.5px;
  font-family: inherit;
}
.ai-search-input::placeholder { color: #94a3b8; }
.ai-search-clear {
  background: none;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  padding: 0;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.ai-search-clear:hover { color: #64748b; }

/* Stats strip */
.ai-stats-strip {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.ai-stat-cell {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px 5px 9px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 600;
  border: 1px solid;
}
.ai-stat-cell-blue {
  background: #2563eb1a;
  border-color: #2563eb33;
  color: #1d4ed8;
}
.ai-stat-cell-green {
  background: #05966914;
  border-color: #05966933;
  color: #059669;
}
.ai-stat-cell-navy {
  background: #1e3a5f1a;
  border-color: #1e3a5f33;
  color: #1e3a5f;
}
.ai-stat-value {
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
}
.ai-stat-label {
  font-size: 11.5px;
  font-weight: 600;
}

/* Category tabs */
.ai-tabs-scroll {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 12px;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}
.ai-tabs-scroll::-webkit-scrollbar { display: none; }

.ai-tab-pill {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 13px;
  border-radius: 20px;
  border: 1.5px solid #e2e8f0;
  cursor: pointer;
  white-space: nowrap;
  font-size: 12.5px;
  font-weight: 500;
  background: #fff;
  color: #475569;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  font-family: inherit;
}
.ai-tab-pill:hover { background: #f1f5f9; color: #0f172a; }
.ai-tab-pill.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
  font-weight: 700;
}

.ai-tab-badge {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 10px;
  background: #f1f5f9;
  color: #64748b;
  font-weight: 600;
}
.ai-tab-pill.active .ai-tab-badge {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

/* ── Scrollable Body ──────────────────────────────────── */
.ai-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px 32px;
  -webkit-overflow-scrolling: touch;
}

/* Connected strip */
.ai-connected-strip {
  background: #fff;
  border-radius: 18px;
  border: 1.5px solid #e2e8f0;
  padding: 12px 14px;
  margin-bottom: 14px;
  box-shadow: 0 2px 8px 0 #0000000a;
}
.ai-connected-header {
  display: flex;
  align-items: center;
  gap: 7px;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #059669;
  margin-bottom: 10px;
}
.ai-connected-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #059669;
  flex-shrink: 0;
}
.ai-connected-chips {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;
}
.ai-connected-chips::-webkit-scrollbar { display: none; }
.ai-connected-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 20px;
  background: #05966914;
  border: 1px solid #05966933;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  color: #059669;
  flex-shrink: 0;
}
.ai-chip-mini-logo {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  object-fit: contain;
}
.ai-chip-mini-mono {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 7px;
  font-weight: 800;
  color: #fff;
  flex-shrink: 0;
}

/* Search results indicator */
.ai-search-results-label {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 12px;
}
.ai-search-results-label em {
  font-style: normal;
  color: #0f172a;
  font-weight: 600;
}

/* Skeleton cards */
@keyframes ai-shimmer {
  0%, 100% { opacity: 0.7; }
  50%       { opacity: 0.35; }
}
.ai-skeleton-card {
  background: #fff;
  border-radius: 18px;
  border: 1.5px solid #e2e8f0;
  padding: 14px;
  margin-bottom: 10px;
  display: flex;
  gap: 12px;
  animation: ai-shimmer 1.4s ease-in-out infinite;
}
.ai-skel-logo {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #e2e8f0;
  flex-shrink: 0;
}
.ai-skel-body { flex: 1; }
.ai-skel-line {
  height: 10px;
  border-radius: 6px;
  background: #e2e8f0;
  margin-bottom: 9px;
}

/* Addon cards */
.ai-addon-card {
  background: #fff;
  border-radius: 18px;
  border: 1.5px solid #e2e8f0;
  margin-bottom: 10px;
  display: flex;
  align-items: stretch;
  box-shadow: 0 2px 8px 0 #0000000a;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.15s, background 0.12s;
  text-align: left;
  width: 100%;
}
.ai-addon-card:hover {
  background: #f8fafc;
  box-shadow: 0 4px 14px 0 #0000001a;
}
.ai-addon-card:active { background: #f1f5f9; }

.ai-addon-stripe { width: 4px; flex-shrink: 0; }

.ai-addon-content {
  flex: 1;
  padding: 12px 12px 12px 14px;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.ai-addon-top {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.ai-addon-logo {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  object-fit: contain;
  flex-shrink: 0;
  background: #f1f5f9;
}
.ai-addon-monogram {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 800;
  color: #fff;
}
.ai-addon-info { flex: 1; min-width: 0; }
.ai-addon-name {
  font-size: 13.5px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}
.ai-addon-desc {
  font-size: 12px;
  color: #64748b;
  margin: 3px 0 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.45;
}
.ai-addon-chevron {
  color: #cbd5e1;
  flex-shrink: 0;
  align-self: center;
  margin-left: 2px;
}
.ai-addon-footer {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 9px;
  flex-wrap: wrap;
}

/* Badges */
.ai-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
  line-height: 1.5;
  border: 1px solid transparent;
}
.ai-badge-green { background: #05966914; border-color: #05966933; color: #059669; }
.ai-badge-amber { background: #d9770614; border-color: #d9770633; color: #b45309; }
.ai-badge-gray  { background: #f1f5f9;   border-color: #e2e8f0;   color: #64748b; }
.ai-badge-blue  { background: #2563eb1a; border-color: #2563eb33; color: #1d4ed8; }
.ai-badge-free  { background: #05966914; border-color: #05966933; color: #059669; }

/* Empty state */
.ai-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 12px;
  text-align: center;
}
.ai-empty-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #2563eb14;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2563eb;
}
.ai-empty-title { font-size: 15px; font-weight: 700; color: #0f172a; margin: 0; }
.ai-empty-sub   { font-size: 13px; color: #64748b; margin: 0; max-width: 300px; }

/* Load more */
.ai-load-more-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  margin: 14px 0 4px;
}
.ai-load-more-btn {
  padding: 7px 22px;
  border-radius: 12px;
  border: 1.5px solid #2563eb33;
  background: #eef3ff;
  color: #2563eb;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: inherit;
  transition: background 0.15s;
}
.ai-load-more-btn:hover:not(:disabled) { background: #dbeafe; }
.ai-load-more-btn:disabled { opacity: 0.55; cursor: not-allowed; }

.ai-pagination-info { font-size: 11px; color: #94a3b8; text-align: center; }

/* Spinners */
@keyframes ai-spin { to { transform: rotate(360deg); } }
.ai-spinner {
  display: inline-block;
  width: 13px;
  height: 13px;
  border: 2px solid #2563eb33;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: ai-spin 0.7s linear infinite;
  flex-shrink: 0;
}
.ai-spinner-blue {
  display: inline-block;
  width: 13px;
  height: 13px;
  border: 2px solid #2563eb33;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: ai-spin 0.7s linear infinite;
  flex-shrink: 0;
}

/* ── Dark mode ───────────────────────────────────────────── */
body.dark .ai-container { background: #0f172a; }
body.dark .ai-header    { background: #1e293b; border-color: #334155; }
body.dark .ai-header-title { color: #f1f5f9; }
body.dark .ai-header-sub   { color: #94a3b8; }
body.dark .ai-back      { background: #1e293b; border-color: #334155; color: #94a3b8; }
body.dark .ai-back:hover { background: #0f172a; }
body.dark .ai-search-bar {
  background: #0f172a;
  border-color: #334155;
}
body.dark .ai-search-bar:focus-within { border-color: #3b82f6; }
body.dark .ai-search-input { color: #f1f5f9; }
body.dark .ai-search-input::placeholder { color: #475569; }
body.dark .ai-search-icon  { color: #475569; }
body.dark .ai-search-clear { color: #475569; }
body.dark .ai-tab-pill {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
body.dark .ai-tab-pill:hover { background: #0f172a; color: #e2e8f0; }
body.dark .ai-tab-pill.active { background: #2563eb; border-color: #2563eb; color: #fff; }
body.dark .ai-tab-badge { background: #334155; color: #64748b; }
body.dark .ai-body { background: #0f172a; }
body.dark .ai-connected-strip { background: #1e293b; border-color: #334155; box-shadow: none; }
body.dark .ai-connected-header { color: #34d399; }
body.dark .ai-connected-dot    { background: #34d399; }
body.dark .ai-connected-chip {
  background: #05966920;
  border-color: #05966940;
  color: #34d399;
}
body.dark .ai-skeleton-card { background: #1e293b; border-color: #334155; }
body.dark .ai-skel-logo,
body.dark .ai-skel-line  { background: #334155; }
body.dark .ai-search-results-label { color: #94a3b8; }
body.dark .ai-search-results-label em { color: #e2e8f0; }
body.dark .ai-addon-card  { background: #1e293b; border-color: #334155; box-shadow: none; }
body.dark .ai-addon-card:hover  { background: #0f172a; }
body.dark .ai-addon-card:active { background: #0a1628; }
body.dark .ai-addon-name  { color: #f1f5f9; }
body.dark .ai-addon-desc  { color: #94a3b8; }
body.dark .ai-addon-chevron { color: #475569; }
body.dark .ai-addon-logo { background: #334155; }
body.dark .ai-empty-title { color: #f1f5f9; }
body.dark .ai-empty-sub   { color: #64748b; }
body.dark .ai-empty-icon  { background: #2563eb22; color: #60a5fa; }
body.dark .ai-badge-gray  { background: #1e293b; border-color: #334155; color: #94a3b8; }
body.dark .ai-badge-blue  { background: #1d4ed820; border-color: #2563eb44; color: #60a5fa; }
body.dark .ai-load-more-btn {
  background: #1e293b;
  border-color: #2563eb55;
  color: #60a5fa;
}
body.dark .ai-load-more-btn:hover:not(:disabled) { background: #0f172a; }
body.dark .ai-pagination-info { color: #475569; }
body.dark .ai-stat-cell-blue  {
  background: #2563eb22;
  border-color: #2563eb44;
  color: #60a5fa;
}
body.dark .ai-stat-cell-green {
  background: #05966922;
  border-color: #05966944;
  color: #34d399;
}
body.dark .ai-stat-cell-navy  {
  background: #1e3a5f33;
  border-color: #1e3a5f55;
  color: #93c5fd;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/AppsIntegrations/index.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,gDAAgD;AAClD;AACA,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE;;AAE7D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA,8BAA8B,uBAAuB,EAAE;AACvD,kBAAkB,cAAc,EAAE,cAAc,EAAE;AAClD;EACE,OAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;AACA,gCAAgC,cAAc,EAAE;AAChD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA,yBAAyB,cAAc,EAAE;;AAEzC,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;AACnC;AACA,qCAAqC,aAAa,EAAE;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,6DAA6D;EAC7D,oBAAoB;AACtB;AACA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;AACA,yCAAyC,aAAa,EAAE;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,WAAW,YAAY,EAAE;EACzB,YAAY,aAAa,EAAE;AAC7B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA,gBAAgB,OAAO,EAAE;AACzB;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C,mBAAmB,UAAU,EAAE,cAAc,EAAE;;AAE/C;EACE,OAAO;EACP,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA,iBAAiB,OAAO,EAAE,YAAY,EAAE;AACxC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,kBAAkB,qBAAqB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AAClF,kBAAkB,qBAAqB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AAClF,kBAAkB,mBAAmB,IAAI,qBAAqB,IAAI,cAAc,EAAE;AAClF,kBAAkB,qBAAqB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AAClF,kBAAkB,qBAAqB,EAAE,uBAAuB,EAAE,cAAc,EAAE;;AAElF,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AAChF,kBAAkB,eAAe,EAAE,cAAc,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEhF,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,4BAA4B;AAC9B;AACA,yCAAyC,mBAAmB,EAAE;AAC9D,6BAA6B,aAAa,EAAE,mBAAmB,EAAE;;AAEjE,sBAAsB,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAE3E,aAAa;AACb,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;AACvD;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;;AAEA,+DAA+D;AAC/D,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE;AACtE,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;AAC7C,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACtF,2BAA2B,mBAAmB,EAAE;AAChD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,wCAAwC,qBAAqB,EAAE;AAC/D,6BAA6B,cAAc,EAAE;AAC7C,0CAA0C,cAAc,EAAE;AAC1D,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;AAC7C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,gCAAgC,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AACzF,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,qBAAqB,mBAAmB,EAAE;AAC1C,gCAAgC,mBAAmB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AAC9F,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,mBAAmB,EAAE;AACtD;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;AACA,8BAA8B,mBAAmB,EAAE,qBAAqB,EAAE;AAC1E;2BAC2B,mBAAmB,EAAE;AAChD,qCAAqC,cAAc,EAAE;AACrD,wCAAwC,cAAc,EAAE;AACxD,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AAC1F,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,mBAAmB,EAAE;AACvD,4BAA4B,cAAc,EAAE;AAC5C,4BAA4B,cAAc,EAAE;AAC5C,8BAA8B,cAAc,EAAE;AAC9C,2BAA2B,mBAAmB,EAAE;AAChD,4BAA4B,cAAc,EAAE;AAC5C,4BAA4B,cAAc,EAAE;AAC5C,4BAA4B,qBAAqB,EAAE,cAAc,EAAE;AACnE,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACxF,4BAA4B,qBAAqB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AAC5F;EACE,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,mDAAmD,mBAAmB,EAAE;AACxE,gCAAgC,cAAc,EAAE;AAChD;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":["/* ════════════════════════════════════════════════════════\n   Apps & Integrations screen\n   ════════════════════════════════════════════════════════ */\n\n.ai-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #f8fafc;\n  font-family: inherit;\n}\n\n/* ── Header ─────────────────────────────────────────────── */\n.ai-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 16px 20px 0;\n  background: #fff;\n  border-bottom: 1.5px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.ai-header-top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.ai-back {\n  width: 32px;\n  height: 32px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 50%;\n  background: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #475569;\n  flex-shrink: 0;\n  transition: border-color 0.15s, background 0.15s;\n}\n.ai-back:hover { background: #f1f5f9; border-color: #cbd5e1; }\n\n.ai-header-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  line-height: 1.2;\n}\n.ai-header-sub {\n  font-size: 11.5px;\n  color: #64748b;\n  margin: 1px 0 0;\n  line-height: 1;\n}\n\n/* Search bar */\n.ai-search-bar {\n  display: flex;\n  align-items: center;\n  background: #f1f5f9;\n  border-radius: 12px;\n  height: 38px;\n  padding: 0 12px;\n  gap: 8px;\n  margin-bottom: 12px;\n  border: 1.5px solid #e2e8f0;\n  transition: border-color 0.15s;\n}\n.ai-search-bar:focus-within { border-color: #2563eb66; }\n.ai-search-icon { color: #94a3b8; flex-shrink: 0; }\n.ai-search-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #0f172a;\n  font-size: 13.5px;\n  font-family: inherit;\n}\n.ai-search-input::placeholder { color: #94a3b8; }\n.ai-search-clear {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #94a3b8;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n.ai-search-clear:hover { color: #64748b; }\n\n/* Stats strip */\n.ai-stats-strip {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n.ai-stat-cell {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px 5px 9px;\n  border-radius: 20px;\n  font-size: 11.5px;\n  font-weight: 600;\n  border: 1px solid;\n}\n.ai-stat-cell-blue {\n  background: #2563eb1a;\n  border-color: #2563eb33;\n  color: #1d4ed8;\n}\n.ai-stat-cell-green {\n  background: #05966914;\n  border-color: #05966933;\n  color: #059669;\n}\n.ai-stat-cell-navy {\n  background: #1e3a5f1a;\n  border-color: #1e3a5f33;\n  color: #1e3a5f;\n}\n.ai-stat-value {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1;\n}\n.ai-stat-label {\n  font-size: 11.5px;\n  font-weight: 600;\n}\n\n/* Category tabs */\n.ai-tabs-scroll {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n  padding-bottom: 12px;\n  scrollbar-width: none;\n  -webkit-overflow-scrolling: touch;\n}\n.ai-tabs-scroll::-webkit-scrollbar { display: none; }\n\n.ai-tab-pill {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 13px;\n  border-radius: 20px;\n  border: 1.5px solid #e2e8f0;\n  cursor: pointer;\n  white-space: nowrap;\n  font-size: 12.5px;\n  font-weight: 500;\n  background: #fff;\n  color: #475569;\n  flex-shrink: 0;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n  font-family: inherit;\n}\n.ai-tab-pill:hover { background: #f1f5f9; color: #0f172a; }\n.ai-tab-pill.active {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n  font-weight: 700;\n}\n\n.ai-tab-badge {\n  font-size: 10px;\n  padding: 1px 6px;\n  border-radius: 10px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-weight: 600;\n}\n.ai-tab-pill.active .ai-tab-badge {\n  background: rgba(255, 255, 255, 0.22);\n  color: #fff;\n}\n\n/* ── Scrollable Body ──────────────────────────────────── */\n.ai-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px 32px;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Connected strip */\n.ai-connected-strip {\n  background: #fff;\n  border-radius: 18px;\n  border: 1.5px solid #e2e8f0;\n  padding: 12px 14px;\n  margin-bottom: 14px;\n  box-shadow: 0 2px 8px 0 #0000000a;\n}\n.ai-connected-header {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #059669;\n  margin-bottom: 10px;\n}\n.ai-connected-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #059669;\n  flex-shrink: 0;\n}\n.ai-connected-chips {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n.ai-connected-chips::-webkit-scrollbar { display: none; }\n.ai-connected-chip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  border-radius: 20px;\n  background: #05966914;\n  border: 1px solid #05966933;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 500;\n  color: #059669;\n  flex-shrink: 0;\n}\n.ai-chip-mini-logo {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  object-fit: contain;\n}\n.ai-chip-mini-mono {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 7px;\n  font-weight: 800;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n/* Search results indicator */\n.ai-search-results-label {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 12px;\n}\n.ai-search-results-label em {\n  font-style: normal;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n/* Skeleton cards */\n@keyframes ai-shimmer {\n  0%, 100% { opacity: 0.7; }\n  50%       { opacity: 0.35; }\n}\n.ai-skeleton-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1.5px solid #e2e8f0;\n  padding: 14px;\n  margin-bottom: 10px;\n  display: flex;\n  gap: 12px;\n  animation: ai-shimmer 1.4s ease-in-out infinite;\n}\n.ai-skel-logo {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: #e2e8f0;\n  flex-shrink: 0;\n}\n.ai-skel-body { flex: 1; }\n.ai-skel-line {\n  height: 10px;\n  border-radius: 6px;\n  background: #e2e8f0;\n  margin-bottom: 9px;\n}\n\n/* Addon cards */\n.ai-addon-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1.5px solid #e2e8f0;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: stretch;\n  box-shadow: 0 2px 8px 0 #0000000a;\n  overflow: hidden;\n  cursor: pointer;\n  transition: box-shadow 0.15s, background 0.12s;\n  text-align: left;\n  width: 100%;\n}\n.ai-addon-card:hover {\n  background: #f8fafc;\n  box-shadow: 0 4px 14px 0 #0000001a;\n}\n.ai-addon-card:active { background: #f1f5f9; }\n\n.ai-addon-stripe { width: 4px; flex-shrink: 0; }\n\n.ai-addon-content {\n  flex: 1;\n  padding: 12px 12px 12px 14px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.ai-addon-top {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n.ai-addon-logo {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  object-fit: contain;\n  flex-shrink: 0;\n  background: #f1f5f9;\n}\n.ai-addon-monogram {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  font-weight: 800;\n  color: #fff;\n}\n.ai-addon-info { flex: 1; min-width: 0; }\n.ai-addon-name {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #0f172a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n}\n.ai-addon-desc {\n  font-size: 12px;\n  color: #64748b;\n  margin: 3px 0 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  line-height: 1.45;\n}\n.ai-addon-chevron {\n  color: #cbd5e1;\n  flex-shrink: 0;\n  align-self: center;\n  margin-left: 2px;\n}\n.ai-addon-footer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 9px;\n  flex-wrap: wrap;\n}\n\n/* Badges */\n.ai-badge {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 3px 9px;\n  border-radius: 20px;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  white-space: nowrap;\n  line-height: 1.5;\n  border: 1px solid transparent;\n}\n.ai-badge-green { background: #05966914; border-color: #05966933; color: #059669; }\n.ai-badge-amber { background: #d9770614; border-color: #d9770633; color: #b45309; }\n.ai-badge-gray  { background: #f1f5f9;   border-color: #e2e8f0;   color: #64748b; }\n.ai-badge-blue  { background: #2563eb1a; border-color: #2563eb33; color: #1d4ed8; }\n.ai-badge-free  { background: #05966914; border-color: #05966933; color: #059669; }\n\n/* Empty state */\n.ai-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  gap: 12px;\n  text-align: center;\n}\n.ai-empty-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: #2563eb14;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #2563eb;\n}\n.ai-empty-title { font-size: 15px; font-weight: 700; color: #0f172a; margin: 0; }\n.ai-empty-sub   { font-size: 13px; color: #64748b; margin: 0; max-width: 300px; }\n\n/* Load more */\n.ai-load-more-row {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 7px;\n  margin: 14px 0 4px;\n}\n.ai-load-more-btn {\n  padding: 7px 22px;\n  border-radius: 12px;\n  border: 1.5px solid #2563eb33;\n  background: #eef3ff;\n  color: #2563eb;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: inherit;\n  transition: background 0.15s;\n}\n.ai-load-more-btn:hover:not(:disabled) { background: #dbeafe; }\n.ai-load-more-btn:disabled { opacity: 0.55; cursor: not-allowed; }\n\n.ai-pagination-info { font-size: 11px; color: #94a3b8; text-align: center; }\n\n/* Spinners */\n@keyframes ai-spin { to { transform: rotate(360deg); } }\n.ai-spinner {\n  display: inline-block;\n  width: 13px;\n  height: 13px;\n  border: 2px solid #2563eb33;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  animation: ai-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n.ai-spinner-blue {\n  display: inline-block;\n  width: 13px;\n  height: 13px;\n  border: 2px solid #2563eb33;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  animation: ai-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n/* ── Dark mode ───────────────────────────────────────────── */\nbody.dark .ai-container { background: #0f172a; }\nbody.dark .ai-header    { background: #1e293b; border-color: #334155; }\nbody.dark .ai-header-title { color: #f1f5f9; }\nbody.dark .ai-header-sub   { color: #94a3b8; }\nbody.dark .ai-back      { background: #1e293b; border-color: #334155; color: #94a3b8; }\nbody.dark .ai-back:hover { background: #0f172a; }\nbody.dark .ai-search-bar {\n  background: #0f172a;\n  border-color: #334155;\n}\nbody.dark .ai-search-bar:focus-within { border-color: #3b82f6; }\nbody.dark .ai-search-input { color: #f1f5f9; }\nbody.dark .ai-search-input::placeholder { color: #475569; }\nbody.dark .ai-search-icon  { color: #475569; }\nbody.dark .ai-search-clear { color: #475569; }\nbody.dark .ai-tab-pill {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\nbody.dark .ai-tab-pill:hover { background: #0f172a; color: #e2e8f0; }\nbody.dark .ai-tab-pill.active { background: #2563eb; border-color: #2563eb; color: #fff; }\nbody.dark .ai-tab-badge { background: #334155; color: #64748b; }\nbody.dark .ai-body { background: #0f172a; }\nbody.dark .ai-connected-strip { background: #1e293b; border-color: #334155; box-shadow: none; }\nbody.dark .ai-connected-header { color: #34d399; }\nbody.dark .ai-connected-dot    { background: #34d399; }\nbody.dark .ai-connected-chip {\n  background: #05966920;\n  border-color: #05966940;\n  color: #34d399;\n}\nbody.dark .ai-skeleton-card { background: #1e293b; border-color: #334155; }\nbody.dark .ai-skel-logo,\nbody.dark .ai-skel-line  { background: #334155; }\nbody.dark .ai-search-results-label { color: #94a3b8; }\nbody.dark .ai-search-results-label em { color: #e2e8f0; }\nbody.dark .ai-addon-card  { background: #1e293b; border-color: #334155; box-shadow: none; }\nbody.dark .ai-addon-card:hover  { background: #0f172a; }\nbody.dark .ai-addon-card:active { background: #0a1628; }\nbody.dark .ai-addon-name  { color: #f1f5f9; }\nbody.dark .ai-addon-desc  { color: #94a3b8; }\nbody.dark .ai-addon-chevron { color: #475569; }\nbody.dark .ai-addon-logo { background: #334155; }\nbody.dark .ai-empty-title { color: #f1f5f9; }\nbody.dark .ai-empty-sub   { color: #64748b; }\nbody.dark .ai-empty-icon  { background: #2563eb22; color: #60a5fa; }\nbody.dark .ai-badge-gray  { background: #1e293b; border-color: #334155; color: #94a3b8; }\nbody.dark .ai-badge-blue  { background: #1d4ed820; border-color: #2563eb44; color: #60a5fa; }\nbody.dark .ai-load-more-btn {\n  background: #1e293b;\n  border-color: #2563eb55;\n  color: #60a5fa;\n}\nbody.dark .ai-load-more-btn:hover:not(:disabled) { background: #0f172a; }\nbody.dark .ai-pagination-info { color: #475569; }\nbody.dark .ai-stat-cell-blue  {\n  background: #2563eb22;\n  border-color: #2563eb44;\n  color: #60a5fa;\n}\nbody.dark .ai-stat-cell-green {\n  background: #05966922;\n  border-color: #05966944;\n  color: #34d399;\n}\nbody.dark .ai-stat-cell-navy  {\n  background: #1e3a5f33;\n  border-color: #1e3a5f55;\n  color: #93c5fd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
